import { useGame } from "../game/GameContext";
import { useSessionView } from "../game/useSessionView";
import "./GameUIRoot.css";
import { CameraGizmoAndZoom } from "./camera/CameraGizmoAndZoom";
import { CardHolder } from "./deck/Cards";
import { DevSidecar } from "./dev/DevSidecar";
import { Icon } from "./icons/Icon";
import { BuildMenu } from "./menus/BuildMenu";
import { ForgeMenu } from "./menus/ForgeMenu";
import { MaterialCounter } from "./menus/MaterialCounter";
import { StyledButtonContainer } from "./shared/StyledButtonContainer";

export function GameUIRoot() {
  return (
    <div className="ui-overlay">
      <div className="top-bar">
        <div className="top-left-readouts">
          <MaterialCounter />
        </div>
        <div className="top-right-gameplay">
          <div className="turn-controls">
            <TurnControls />
          </div>
          <CameraGizmoAndZoom />
        </div>
      </div>
      <div className="bottom-overlay">
        <div className="bottom-left-buttons">
          <ForgeMenu />
          <BuildMenu />
        </div>
        <div className="bottom-center">
          <CardHolder />
        </div>
        <div className="bottom-right-buttons">
          <StyledButtonContainer className="simple-button">
            <Icon icon="pawn" className="simple-icon" />
          </StyledButtonContainer>
          <StyledButtonContainer className="simple-button">
            <Icon icon="gear" className="simple-icon" />
          </StyledButtonContainer>
        </div>
      </div>
      <DevSidecar />
    </div>
  );
}

function TurnControls() {
  const game = useGame();
  const turnRow = useSessionView()?.turnRow;

  return (
    <>
      <StyledButtonContainer
        className="simple-button"
        disabled={!turnRow || !!turnRow.undoRefusal}
        onClick={() => game.play({ kind: "undo" })}
      >
        <Icon icon="undo" className="simple-icon" />
      </StyledButtonContainer>
      <StyledButtonContainer
        className="simple-button"
        disabled={!turnRow || !!turnRow.endTurn.refusal}
        showIndicator
        indicatorLit={turnRow?.endTurn.ready}
        onClick={() => {
          if (!turnRow) return;
          game.session?.choose(turnRow.endTurn.option);
        }}
      >
        <Icon icon="endTurn" className="simple-icon" />
      </StyledButtonContainer>
    </>
  );
}
